module.exports = __webpack_public_path__ + "img/icon-gold20.cc76c7df.png";